import { PAYWALL_TYPE } from './types';

/* eslint-disable import/prefer-default-export */
export const paywallTypeAction = (paywallType) => ({
    type: PAYWALL_TYPE,
    payload: paywallType,
});
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/paywall-type.js
 **/